// SettingsPage.jsx
import React, { useState } from "react";
import { Container, Box, Grid, Typography, Switch, FormControlLabel, Button } from "@mui/material";
import AccountSidebarNav from "../../Components/AccountComponents/AccountSideNacv";

export default function Setting() {
    const [whatsappEnabled, setWhatsappEnabled] = useState(false);
    const [deleteConfirm, setDeleteConfirm] = useState(false);

    return (
        <Container maxWidth={false} sx={{
            py: 2,
            // Responsive maxWidth for different screen sizes
            maxWidth: {
                xs: '100%',  // Mobile
                sm: '95%',   // Small tablets
                md: '92%',   // Tablets and small laptops
                lg: '90%',   // Large screens
                xl: '90%',   // Very large displays
            },
            mx: 'auto', // Center align container
        }}>
            {/* Breadcrumb */}
            <Box
                sx={{
                    mb: 2,
                    pb: 2,
                    borderBottom: "1px solid #e5e5e5",
                }}
            >
                <Typography
                    sx={{
                        textTransform: "uppercase",
                        fontSize: "12px",
                        letterSpacing: "0.05em",
                        color: "text.secondary",
                    }}
                >
                    <span style={{ color: "#000" }}>My Account</span>
                    <span style={{ margin: "0 8px" }}>{">"}</span>
                    <span style={{ color: "#000" }}>My Settings</span>
                </Typography>
            </Box>

            {/* Layout */}
            <Grid container spacing={4}>
                {/* Sidebar */}
                <Grid item xs={12} md={3}>
                    <AccountSidebarNav active="Settings" />
                </Grid>

                {/* Content */}
                <Grid item xs={12} md={9}>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 6 }}>
                        <Typography
                            variant="subtitle2"
                            sx={{
                                textTransform: "uppercase",
                                fontWeight: 600,
                                letterSpacing: "0.05em",
                                color: "text.primary",
                                fontSize: "14px",
                            }}
                        >
                            My Settings
                        </Typography>

                        {/* WhatsApp Notifications */}
                        <Box sx={{ borderBottom: "1px solid #e5e5e5", pb: 4 }}>
                            <Box sx={{ display: "flex", justifyContent: "space-between", gap: 3 }}>
                                <Box sx={{ flex: 1 }}>
                                    <Typography
                                        variant="subtitle2"
                                        sx={{ fontWeight: 500, color: "text.primary", mb: 1, fontSize: "14px" }}
                                    >
                                        WhatsApp Notifications
                                    </Typography>
                                    <Typography sx={{ color: "text.secondary", fontSize: "14px", lineHeight: 1.6 }}>
                                        By opting for WhatsApp updates, you consent to receiving notifications from Pernia's Pop-Up Shop
                                        regarding your order status, and shipping details, as well as updates on marketing and promotional
                                        activities.
                                    </Typography>
                                </Box>
                                <Switch
                                    checked={whatsappEnabled}
                                    onChange={() => setWhatsappEnabled(!whatsappEnabled)}
                                    inputProps={{ "aria-label": "Toggle WhatsApp notifications" }}
                                />
                            </Box>
                        </Box>

                        {/* Delete Account Section */}
                        <Box>
                            <Typography
                                variant="subtitle2"
                                sx={{ color: "blue", fontWeight: 500, mb: 2, fontSize: "14px" }}
                            >
                                Delete My Account
                            </Typography>

                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={deleteConfirm}
                                        onChange={(e) => setDeleteConfirm(e.target.checked)}
                                        sx={{ mr: 1 }}
                                    />
                                }
                                label="Yes, I want to permanently close my Account and delete my data."
                                sx={{ color: "text.primary", fontSize: "14px", alignItems: "flex-start", mb: 2 }}
                            />

                            <Button
                                variant="contained"
                                disabled={!deleteConfirm}
                                sx={{
                                    bgcolor: "#000",
                                    px: 4,
                                    py: 1.5,
                                    textTransform: "uppercase",
                                    fontSize: "14px",
                                    letterSpacing: "0.05em",
                                    "&:disabled": { opacity: 0.5 },
                                }}
                            >
                                Delete My Account
                            </Button>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Container>
    );
}
